<template>
  <v-dialog
      v-model="dialog"
      max-width="640"
      persistent
  >
    <v-card>
      <v-card-title class="headline">Registrar consultorio</v-card-title>

      <v-divider></v-divider>

      <v-card-text class="pt-5">
        <v-form ref="formCreateOffice" @submit.prevent="createOffice">
          <v-row>
            <v-col cols="12" sm="8">
              <v-text-field
                  v-model="office.name"
                  label="Nombre *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.counter]"
                  prefix="DIETEC"
              />
            </v-col>
            <v-col cols="12" sm="4">
              <v-text-field
                  v-model="office.code"
                  label="Código *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.code]"
                  counter
                  maxlength="8"
                  minlength="4"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                  v-model="office.province"
                  :items="provinces"
                  label="Estado *"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-select
                  v-model="office.city"
                  :items="cities"
                  label="Municipio *"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                  :disabled="!office.province"
                  v-if="office.province !== 'Otro / Extranjero'"
              />
              <v-text-field
                  v-model="office.city"
                  label="Ciudad *"
                  outlined
                  dense
                  required
                  :rules="[rules.required]"
                  v-else
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="office.district"
                  label="Colonia *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.counter]"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                  v-model="office.street"
                  label="Calle y número *"
                  outlined
                  dense
                  required
                  :rules="[rules.required, rules.counter]"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <CancelButton
            @click="handleDialogClose"
            :isDisabled="isLoading"
        />
        <CreateButton
            @click="createOffice"
            :isLoading="isLoading"
            :isDisabled="isInvalidForm"
            label="Registrar consultorio"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import Vue from "vue";

import OfficeService from "@/services/offices/OfficeService";

import throwSuccessMessage from "@/utils/SuccessMessage";
import throwErrorMessage from "@/utils/ErrorMessage";

import {provinces} from "@/utils/Locations";
import {cities} from "@/utils/Locations";

import {RequestCreateOffice} from "@/services/offices/entities/RequestCreateOffice";
import CancelButton from "@/components/buttons/CancelButton.vue";
import CreateButton from "@/components/buttons/CreateButton.vue";

export default Vue.extend({
  name: "DialogCreateOffice",
  components: {CreateButton, CancelButton},
  data() {
    return {
      // Dialog
      dialog: false as boolean,

      // Office
      office: {} as RequestCreateOffice,

      // Address
      provinces: provinces,
      cities: [] as string[],

      // Loading
      isLoading: false as boolean,

      // Rules
      rules: {
        required: (value: string) => !!value || 'Campo requerido',
        counter: (value: string) => (value || '').length <= 50 || 'Máximo 50 caracteres',
        code: (value: string) => (value || '').length >= 4 && (value || '').length <= 8 || 'Mínimo 4 y máximo 8 caracteres',
      },
    };
  },

  watch: {
    'office.province': function (val: string) {
      this.cities = cities[val] || [];
    },
  },

  computed: {
    isInvalidForm(): boolean {
      return (
          !this.office.name ||
          !this.office.code ||
          !this.office.province ||
          !this.office.city ||
          !this.office.district ||
          !this.office.street
      );
    }
  },

  methods: {
    async createOffice() {
      this.isLoading = true;
      try {
        const form = this.$refs.formCreateOffice as any;
        if (!form.validate()) {
          throwErrorMessage("Asegúrate de llenar todos los campos correctamente");
          return;
        }

        if (this.office.name.toUpperCase().startsWith("DIETEC")) {
          throwErrorMessage("El nombre del consultorio no puede empezar con DIETEC");
          return;
        }
        const body: RequestCreateOffice = {
          name: this.office.name,
          code: this.office.code,
          province: this.office.province,
          city: this.office.city,
          district: this.office.district,
          street: this.office.street,
        }

        await OfficeService.createOffice(body);
        throwSuccessMessage(`Se ha registrado DIETEC ${this.office.name} correctamente`);
        this.$emit("office-created");
        this.handleDialogClose();
      } finally {
        this.isLoading = false;
      }
    },

    handleDialogClose() {
      const form = this.$refs.formCreateOffice as any;
      form.resetValidation();
      form.reset();
      this.dialog = false;
    },
  },

  created() {
    this.provinces.push("Otro / Extranjero");
  }
});
</script>